import React from 'react';
import chairmanImage from '../assets/chairman.png';

const Greeting = () => {
  return (
    <section id="greeting" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">実行委員長挨拶</h2>
          <div className="w-20 h-1 bg-blue-900 mx-auto"></div>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-12">
          <div className="w-full md:w-1/3">
            <div className="relative">
              <div className="absolute inset-0 border-2 border-yellow-600 transform translate-x-4 translate-y-4"></div>
              <img
                src={chairmanImage}
                alt="実行委員長"
                className="relative w-full h-auto shadow-lg grayscale hover:grayscale-0 transition-all duration-500"
              />
            </div>
            <div className="mt-6 text-center md:text-left">
              <p className="text-sm text-gray-500 mb-1">実行委員長</p>
              <p className="text-xl font-bold text-gray-900">戸塚　亮一</p>
              <p className="text-sm text-gray-500 mt-1">Ryoichi TOTSUKA</p>
            </div>
          </div>

          <div className="w-full md:w-2/3">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              音楽を通じて、<br className="md:hidden"/>新たな絆が生まれる場所へ
            </h3>
            <div className="space-y-4 text-gray-600 leading-relaxed text-justify">
              <p>第2回大学対抗ピアノ演奏チームコンテストの開催にあたり、ご挨拶申し上げます。 昨年、記念すべき第1回大会を開催し、多くの学生ピアニストたちの情熱あふれる演奏に心を打たれました。 本コンテストは、単なる技術の競い合いではなく、チームとしての結束、そして音楽を通じた大学間の交流を通じてクラシック業界の活性化を目的としています。</p>
              <p>
                ピアノは孤独な楽器だと言われることがありますが、アンサンブルやチーム対抗という形式をとることで、
                仲間と共に音楽を作り上げる喜び、そして分かち合う感動を体験していただきたいと願っております。
              </p>
              <p>
                今回も、全国から素晴らしい才能が集結し、天空劇場という最高の舞台で、
                若きピアニストたちがどのようなハーモニーを奏でてくれるのか、今から楽しみでなりません。
                皆様のご参加とご来場を心よりお待ちしております。
              </p>
            </div>
            <div className="mt-8">
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/f/f8/Signature_sample.svg" 
                alt="Signature" 
                className="h-12 opacity-60"
              />
            </div>

            {/* プロフィール追加 */}
            <div className="mt-8 pt-6 border-t border-gray-200 text-xs text-gray-500 leading-relaxed text-justify">
              <p>
                <span className="font-bold text-gray-700">戸塚 亮一（とつか りょういち）</span><br/>
                (株)ベヒシュタイン・ジャパン創業者。1974年より河合楽器の初代駐在員として独赴任を経て、1980年に独立。世界最高峰のピアノ「ベヒシュタイン」等の日本総代理店を設立。長年、欧州音楽文化の普及に尽力し、大学での講師歴も持つ。また、楽譜が読めなくても即座に演奏を楽しめる独自の「トツカ・ピアノメソッド」を考案。同教材が「通販生活」で1万2千部を突破するなど、ピアノ教育の新たな可能性を切り拓いている。また日本音楽コンクールや全日本学生音楽コンクールの支援も毎年行っている。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Greeting;
